'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TelefoonConstants = {
    CONTACT_RESOURCE_SITECORE: '/api/v1/json-documents?name=contact',
    CONTACT_RESOURCE_SHAREPOINT: '/json/contact.json.js',
    DEFAULT_SCHEDULE: 'ALGEMEEN',
    MESSAGES: {
        straks: 'Van {open} tot {gesloten} uur',
        nu: 'Tot {gesloten} uur',
        morgen: 'Vanaf morgen weer van {open} tot {gesloten} uur',
        later: 'Vanaf {dag} weer van {open} tot {gesloten} uur'
    }
};

exports.default = TelefoonConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/telefoon/telefoon.constants.js
// module id = 826
// module chunks = 0